
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"721cabf2bea19908b25a4677d7fff9cff641dfb6":"$$ACTION_0","ea43629739b4fbf3c1ee37f227d4620f759773af":"startRewardfulImportAction"} */ export var startRewardfulImportAction = createServerReference("ea43629739b4fbf3c1ee37f227d4620f759773af");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

